import p from "./ghl-ui.es834.js";
function c(r, e) {
  var t = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    e && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function y(r) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? c(Object(t), !0).forEach(function(n) {
      b(r, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(t)) : c(Object(t)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return r;
}
function b(r, e, t) {
  return e in r ? Object.defineProperty(r, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : r[e] = t, r;
}
function d(r, e) {
  return _(r) || O(r, e) || m(r, e) || g();
}
function g() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function m(r, e) {
  if (r) {
    if (typeof r == "string")
      return s(r, e);
    var t = Object.prototype.toString.call(r).slice(8, -1);
    if (t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set")
      return Array.from(r);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return s(r, e);
  }
}
function s(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var t = 0, n = new Array(e); t < e; t++)
    n[t] = r[t];
  return n;
}
function O(r, e) {
  var t = r == null ? null : typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t != null) {
    var n = [], a = !0, i = !1, u, f;
    try {
      for (t = t.call(r); !(a = (u = t.next()).done) && (n.push(u.value), !(e && n.length === e)); a = !0)
        ;
    } catch (o) {
      i = !0, f = o;
    } finally {
      try {
        !a && t.return != null && t.return();
      } finally {
        if (i)
          throw f;
      }
    }
    return n;
  }
}
function _(r) {
  if (Array.isArray(r))
    return r;
}
function h(r) {
  var e = Array.prototype.slice.call(r), t = d(e, 4), n = t[0], a = t[1], i = t[2], u = t[3], f, o, l;
  if (typeof n == "string")
    f = n;
  else
    throw new TypeError("A text for parsing must be a string.");
  if (!a || typeof a == "string")
    u ? (o = i, l = u) : (o = void 0, l = i), a && (o = y({
      defaultCountry: a
    }, o));
  else if (p(a))
    i ? (o = a, l = i) : l = a;
  else
    throw new Error("Invalid second argument: ".concat(a));
  return {
    text: f,
    options: o,
    metadata: l
  };
}
export {
  h as default
};
